<template lang="pug">
    div.image-editor-control(v-if='imageData')
        tabs-control.image-editor-control__tabs(v-model='activeTab' :tabs='tabs')
            template(v-slot:content-crop)
                image-editor-crop-control(:image="imageData" ref="crop")
            template(v-slot:content-filters)
                image-editor-filters-control(:image="imageData" :watermark="watermark" ref="filters")
            template(v-slot:content-edit)
                image-editor-color-control(:image="imageData" :watermark="watermark" ref="edit")
</template>

<script>
export default {
    name: 'image-editor-control',

    props: {
        image: {
            type: [File, String],
            required: true
        },
        watermark: {
            type: Object,
        },
    },

    data() {
        return {
            activeTab: null,
            imageData: null,
        }
    },

    computed: {
        tabs() {
            return [
                { name: 'crop', label: 'Crop', iconId: 'shield-exclamation'},
                { name: 'filters', label: 'Filters', iconId: 'filters' },
                { name: 'edit', label: 'Edit', iconId: 'magic-wand' },
            ]
        },
    },

    watch: {
        image: {
            handler(data) {
                this.setImageData(data)
            },
            deep: true,
            immediate: true,
        },
        activeTab(val) {
            const { name, label } = this.tabs.find(t => t.name === val)
            this.$emit('changeTab', {
                name,
                label,
            })
        },
    },

    methods: {
        setImageData(data) {
            if (typeof(data) == 'string') {
                axios.get(data, { responseType: 'blob' }).then(({data: b}) => {
                    this.readAndSetData(b)
                })
            }
            else {
                this.readAndSetData(data)
            }
        },

        readAndSetData(data) {
            const reader = new FileReader()
            reader.onload = (event) => {
                this.imageData = event.target.result
            };
            reader.readAsDataURL(data)
        },

        updateImage(data) {
            const image = this.dataUrlToFile(data, 'Modified Image')
            this.$emit('change', image)
        },

        dataUrlToFile(data, filename) {
            let arr = data.split(',')
            let mime = arr[0].match(/:(.*?);/)[1]
            let bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type: mime});
        },

        async apply() {
            const component = this.$refs[this.activeTab]
            this.updateImage(await component.getModifiedImage())
        },
    },
}
</script>
